import React from 'react';
import PropTypes from 'prop-types';

function ExternalRegistry(props) {
  const { registry, idx, onExternalRegistryClick } = props;

  return (
    <div className="non-zola">
      <div id={`other-registry-${idx}`} />
      <div className="left-content">
        <p className="registry-name">{registry.name}</p>
        {registry.description && (
          <p>
            {registry.description}
          </p>
        )}
      </div>
      <div className="right-content">
        {registry.url && (
          <a role="button" className="btn btn-primary btn-wide" onClick={() => onExternalRegistryClick(registry.url)}>
            See Registry
          </a>
        )}
      </div>
      <div style={{ clear: 'both' }} />
    </div>
  );
}

ExternalRegistry.propTypes = {
  registry: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    url: PropTypes.string,
    description: PropTypes.string
  }),
  idx: PropTypes.number.isRequired,
  onExternalRegistryClick: PropTypes.func.isRequired
};

export default ExternalRegistry;



/** WEBPACK FOOTER **
 ** ./src/components/registry/ExternalRegistry.jsx
 **/